export class DispenseTabs {
  static MEDORDER_TAB = 'MedOrder';
  static INVENTORY_TAB = 'Inventory';
  static HISTORY_TAB = 'History';
  static SELECTED_TAB = 'Selected';
}
